import { CommonModule } from '@angular/common';
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { ProctoringSidebarComponent } from '../proctoring-sidebar/proctoring-sidebar.component';
import { ProctoringHeaderComponent } from '../proctoring-header/proctoring-header.component';
import { filter, Subscription } from 'rxjs';
import { AuthServiceService } from '@edtech-ui/core/services/authService/auth-service.service';
import { ToastrService } from 'ngx-toastr';

@Component({
	selector: 'app-proctoring-main-dashboard',
	standalone: true,
	imports: [
		CommonModule,
		RouterOutlet,
		ProctoringSidebarComponent,
		ProctoringHeaderComponent
	],
	templateUrl: './proctoring-main-dashboard.component.html',
	styleUrl: './proctoring-main-dashboard.component.scss'
})
export class ProctoringMainDashboardComponent implements OnInit, OnDestroy {

	isSidebarCollapsed = false;
	isMobileMenuOpen = false;
	activeTab = 'dashboard';
	globalSearchQuery = '';
	showPendingModal = false;
	registeredEmail = '';
	private routerSub!: Subscription;


	constructor(
		private router: Router,
		private _authService: AuthServiceService,
		private _toastr: ToastrService
	) {

		this.routerSub = this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
			this.updateActiveTabFromRoute();
		});
	}


	ngOnInit(): void {
		this.checkScreenSize();
		this.updateActiveTabFromRoute();
	}

	@HostListener('window:resize', ['$event'])
	onResize(event: any) {
		this.checkScreenSize();
	}

	private checkScreenSize(): void {
		if (window.innerWidth <= 1200) {
			this.isSidebarCollapsed = false;
		} else {
			this.isSidebarCollapsed = false;
			this.isMobileMenuOpen = false;
		}
	}


	private updateActiveTabFromRoute(): void {
		const url = this.router.url;
		if (url.includes('/proctoring-dashboard/dashboard')) {
			this.activeTab = 'dashboard';
		} else if (url.includes('/proctoring-dashboard/proto-rules')) {
			this.activeTab = 'proto-rules';
		} else if (url.includes('/proctoring-dashboard/proto-configs')) {
			this.activeTab = 'proto-configs';
		} else if (url.includes('/proctoring-dashboard/proto-assessment')) {
			this.activeTab = 'proto-assessment';
		}
	}


	toggleSidebar(): void {
		if (window.innerWidth <= 1200) {
			this.isMobileMenuOpen = false;
		} else {
			this.isSidebarCollapsed = !this.isSidebarCollapsed;
		}
	}


	toggleMobileMenu(): void {
		if (window.innerWidth <= 1200) {
			this.isMobileMenuOpen = !this.isMobileMenuOpen;
		} else {
			this.toggleSidebar();
		}
	}


	setActiveTab(tab: string): void {
		this.activeTab = tab;
		this.isMobileMenuOpen = false;

		switch (tab) {
			case 'dashboard':
				this.router.navigate(['/proctoring-dashboard/dashboard']);
				break;

			case 'proto-rules':
				this.router.navigate(['/proctoring-dashboard/proto-rules']);
				break;

			case 'proto-configs':
				this.router.navigate(['/proctoring-dashboard/proto-configs']);
				break;

			case 'proto-assessment':
				this.router.navigate(['/proctoring-dashboard/proto-assessment']);
				break;
		}
	}



	logout(): void {
		this.routerSub.add(
			this._authService.logout(this.router).subscribe({
				next: (response) => {
					if (response.Success) {
						this._toastr.success('Logged out successfully.');
					} else {
						this._toastr.error(response.Message || 'Logout failed');
					}
				},
				error: () => {
					this._toastr.error('An error occurred during logout');
				}
			})
		);
	}


	onGlobalSearch(query: string): void {
		this.globalSearchQuery = query;
	}


	ngOnDestroy(): void {
		if (this.routerSub) {
			this.routerSub.unsubscribe();
		}
	}

}
